(() => {
  const config = window.MuseOilArt || {};
  const cartType = config.cartType || window.themeVariables?.settings?.cartType || 'page';
  const body = document.body;
  const overlay = document.querySelector('[data-overlay]');

  const money = (cents) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: config.currency || 'USD' }).format(value);
    } catch {
      return `$${value.toFixed(2)}`;
    }
  };

  const lock = () => body.classList.add('muse-lock');
  const unlock = () => {
    if (!document.querySelector('.is-open[data-drawer], .is-open[data-cart-drawer], .is-open[data-offer-modal], .is-open[data-collection-filter], .is-open[data-image-lightbox], .is-open[data-review-modal]')) body.classList.remove('muse-lock');
  };
  const showOverlay = () => overlay?.classList.add('is-open');
  const hideOverlay = () => {
    if (!document.querySelector('.is-open[data-drawer], .is-open[data-cart-drawer], .is-open[data-offer-modal], .is-open[data-collection-filter], .is-open[data-image-lightbox], .is-open[data-review-modal]')) overlay?.classList.remove('is-open');
  };
  const drawerReturnFocus = new WeakMap();
  document.querySelectorAll('[data-drawer], [data-cart-drawer]').forEach((drawer) => { drawer.inert = !drawer.classList.contains('is-open'); });

  function closeAll() {
    const openReview = document.querySelector('[data-review-modal].is-open');
    if (document.querySelector('[data-offer-modal].is-open')) closeOffer();
    let returnFocus;
    document.querySelectorAll('.is-open[data-drawer], .is-open[data-cart-drawer], .is-open[data-offer-modal], .is-open[data-collection-filter], .is-open[data-image-lightbox], .is-open[data-review-modal]').forEach((element) => {
      element.classList.remove('is-open');
      if (element.matches('[data-drawer], [data-cart-drawer]')) {
        element.inert = true;
        returnFocus = drawerReturnFocus.get(element);
      }
      element.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-drawer-open], [data-country-toggle], [data-collection-filter-open]').forEach((element) => element.setAttribute('aria-expanded', 'false'));
    overlay?.classList.remove('is-open');
    body.classList.remove('muse-lock');
    body.classList.remove('muse-offer-active');
    document.querySelector('.muse-country-form')?.classList.remove('is-open');
    openReview?.dispatchEvent(new Event('muse:review-closed'));
    if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-drawer-open]');
    if (openButton) {
      closeAll();
      const drawer = document.querySelector(`[data-drawer="${openButton.dataset.drawerOpen}"]`);
      if (!drawer) return;
      drawerReturnFocus.set(drawer, openButton);
      drawer.inert = false;
      drawer?.classList.add('is-open');
      drawer?.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      showOverlay();
      lock();
      drawer?.querySelector('input, button, a')?.focus();
      return;
    }
    if (event.target.closest('[data-drawer-close], [data-overlay]')) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  const countryForm = document.querySelector('.muse-country-form');
  const countryToggle = document.querySelector('[data-country-toggle]');
  countryToggle?.addEventListener('click', (event) => {
    const isOpen = countryForm?.classList.toggle('is-open');
    event.currentTarget.setAttribute('aria-expanded', String(Boolean(isOpen)));
  });
  document.addEventListener('click', (event) => {
    if (!countryForm?.classList.contains('is-open') || countryForm.contains(event.target)) return;
    countryForm.classList.remove('is-open');
    countryToggle?.setAttribute('aria-expanded', 'false');
  });

  const announcement = document.querySelector('[data-announcement]');
  const announcementKey = 'muse-announcement-closed';
  if (announcement && sessionStorage.getItem(announcementKey) === '1') announcement.hidden = true;
  document.querySelector('[data-announcement-close]')?.addEventListener('click', () => {
    announcement.hidden = true;
    sessionStorage.setItem(announcementKey, '1');
  });
  const header = document.querySelector('.muse-header');
  const updateHeaderScroll = () => header?.classList.toggle('is-stuck', window.scrollY > 0 && header.getBoundingClientRect().top <= 0);
  const measureHeader = () => {
    if (!header) return;
    const height = `${header.getBoundingClientRect().height}px`;
    document.documentElement.style.setProperty('--header-height', height);
    document.documentElement.style.setProperty('--sticky-area-height', height);
  };
  if (header) {
    measureHeader();
    if ('ResizeObserver' in window) new ResizeObserver(measureHeader).observe(header);
    window.addEventListener('resize', measureHeader, { passive: true });
    window.addEventListener('scroll', updateHeaderScroll, { passive: true });
    updateHeaderScroll();
  }
  const menuItems = [...document.querySelectorAll('.muse-nav__item')].filter(item => item.querySelector(':scope > button') && item.querySelector('.muse-mega-menu, .muse-nav-popover'));
  const setMenuOpen = (item, open, dismissed = false) => {
    item.classList.toggle('is-menu-open', open);
    item.classList.toggle('is-menu-dismissed', dismissed);
    item.querySelector(':scope > button').setAttribute('aria-expanded', String(open));
  };
  menuItems.forEach(item => {
    const button = item.querySelector(':scope > button');
    let hovered = false;
    const openMenu = () => {
      menuItems.filter(other => other !== item).forEach(other => setMenuOpen(other, false, true));
      setMenuOpen(item, true);
    };
    item.addEventListener('mouseenter', () => { hovered = true; openMenu(); });
    item.addEventListener('mouseleave', () => {
      hovered = false;
      if (!item.contains(document.activeElement)) setMenuOpen(item, false);
    });
    item.addEventListener('focusin', () => {
      if (!item.classList.contains('is-menu-dismissed')) openMenu();
    });
    item.addEventListener('focusout', event => {
      if (!item.contains(event.relatedTarget)) setMenuOpen(item, hovered && !item.classList.contains('is-menu-dismissed'));
    });
    // Capture the state before pointer focus so touch activation does not immediately close its own menu.
    let openedBeforePointer;
    button.addEventListener('pointerdown', () => { openedBeforePointer = button.getAttribute('aria-expanded') === 'true'; });
    button.addEventListener('click', event => {
      const open = event.detail > 0 ? !openedBeforePointer : button.getAttribute('aria-expanded') !== 'true';
      openedBeforePointer = undefined;
      if (open) openMenu();
      else setMenuOpen(item, false, true);
    });
    item.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        setMenuOpen(item, false, true);
        button.focus({ preventScroll: true });
      } else if (event.key === 'ArrowDown' && event.target === button) {
        event.preventDefault();
        openMenu();
        item.querySelector('.muse-mega-menu a, .muse-nav-popover a')?.focus();
      }
    });
  });
  document.addEventListener('click', event => {
    menuItems.filter(item => !item.contains(event.target)).forEach(item => setMenuOpen(item, false, true));
  });
  document.querySelectorAll('[data-countdown-end]').forEach((container) => {
    const countdown = container.querySelector('[data-countdown]') || container;
    const end = Date.parse(container.dataset.countdownEnd || '');
    if (!Number.isFinite(end)) return;
    const updateCountdown = () => {
      const remaining = Math.max(0, end - Date.now());
      container.hidden = remaining === 0 || (container === announcement && sessionStorage.getItem(announcementKey) === '1');
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      const pad = (value) => String(value).padStart(2, '0');
      countdown.querySelector('[data-days]').textContent = pad(days);
      countdown.querySelector('[data-hours]').textContent = pad(hours);
      countdown.querySelector('[data-minutes]').textContent = pad(minutes);
      countdown.querySelector('[data-seconds]').textContent = pad(seconds);
    };
    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
  document.querySelectorAll('[data-cart-urgency]').forEach((container) => {
    const minutesNode = container.querySelector('[data-cart-urgency-minutes]');
    const secondsNode = container.querySelector('[data-cart-urgency-seconds]');
    if (!minutesNode || !secondsNode) return;
    const duration = 10 * 60 * 1000;
    const key = 'muse-cart-urgency-start';
    let startedAt = Number(sessionStorage.getItem(key));
    if (!Number.isFinite(startedAt) || startedAt > Date.now() || Date.now() - startedAt >= duration) {
      startedAt = Date.now();
      sessionStorage.setItem(key, String(startedAt));
    }
    const pad = (value) => String(value).padStart(2, '0');
    const updateCartUrgency = () => {
      const remaining = Math.max(0, duration - (Date.now() - startedAt));
      const seconds = Math.ceil(remaining / 1000);
      minutesNode.textContent = pad(Math.floor(seconds / 60));
      secondsNode.textContent = pad(seconds % 60);
      if (remaining === 0) {
        startedAt = Date.now();
        sessionStorage.setItem(key, String(startedAt));
      }
    };
    updateCartUrgency();
    setInterval(updateCartUrgency, 1000);
  });

  function deliveryDates(settings, now) {
    const workingDay = (date) => settings.workingDays.includes(date.getDay());
    const addDays = (date, count) => {
      const next = new Date(date);
      while (count > 0) {
        next.setDate(next.getDate() + 1);
        if (workingDay(next)) count--;
      }
      return next;
    };
    const cutoff = new Date(now);
    cutoff.setHours(settings.cutoffHour, 0, 0, 0);
    const start = new Date(now);
    if (now >= cutoff) start.setDate(start.getDate() + 1);
    while (!workingDay(start)) start.setDate(start.getDate() + 1);
    if (now >= cutoff || !workingDay(now)) {
      cutoff.setFullYear(start.getFullYear(), start.getMonth(), start.getDate());
    }
    const processingFrom = addDays(start, settings.processingMin);
    const processingTo = addDays(start, settings.processingMax);
    // The source widget estimates transit after the latest processing date.
    return { purchased: now, processingFrom, processingTo, from: addDays(processingTo, settings.transitMin), to: addDays(processingTo, settings.transitMax), cutoff };
  }
  document.querySelectorAll('[data-delivery-estimate]').forEach((container) => {
    const settings = JSON.parse(container.querySelector('[data-delivery-config]').textContent);
    if (!settings.workingDays?.length) return;
    const pad = (value) => String(value).padStart(2, '0');
    const fullDate = (date) => `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
    const shortDate = (date) => date.toLocaleDateString('en-US', { month: 'short', day: '2-digit' });
    const range = (from, to) => `${shortDate(from)} - ${from.getMonth() === to.getMonth() ? pad(to.getDate()) : shortDate(to)}`;
    const update = () => {
      const now = new Date();
      const dates = deliveryDates(settings, now);
      const minutes = Math.max(0, Math.floor((dates.cutoff - now) / 60000));
      container.querySelector('[data-delivery-counter]').textContent = `${pad(Math.floor(minutes / 60))} h ${pad(minutes % 60)} min`;
      container.querySelector('[data-delivery-range]').textContent = `${fullDate(dates.from)} to ${fullDate(dates.to)}`;
      container.querySelector('[data-delivery-purchased]').textContent = shortDate(dates.purchased);
      container.querySelector('[data-delivery-processing]').textContent = range(dates.processingFrom, dates.processingTo);
      container.querySelector('[data-delivery-delivered]').textContent = range(dates.from, dates.to);
      container.hidden = false;
    };
    update();
    setInterval(update, 1000);
  });

  const offer = document.querySelector('[data-offer-modal]');
  const offerTeaser = document.querySelector('[data-offer-teaser]');
  const offerTrigger = document.querySelector('[data-offer-open]');
  const offerForm = offer?.querySelector('#MuseOfferForm') || offer?.querySelector('form');
  const offerSuccessMessage = offer?.querySelector('[data-offer-success-message]');
  const offerClientError = offer?.querySelector('[data-offer-client-error]');
  const offerSubmit = offerForm?.querySelector('button[type="submit"], button:not([type])');
  let offerTimer;
  let offerReturnFocus;
  if (offer) offer.inert = true;
  const dismissOfferTimer = () => {
    window.clearTimeout(offerTimer);
    sessionStorage.setItem('muse-offer-seen', '1');
  };
  const offerScale = () => {
    if (!offer) return;
    const scale = Math.min(1, Math.max(0.4, (window.innerWidth - 15) / 780));
    offer.style.setProperty('--muse-offer-scale', String(scale));
    offer.style.setProperty('--muse-offer-offset', `${12 * scale}px`);
  };
  function openOffer() {
    if (!offer) return;
    window.clearTimeout(offerTimer);
    if (offer.classList.contains('is-open')) return;
    closeAll();
    offerReturnFocus = document.activeElement;
    offerScale();
    offer.inert = false;
    offer.classList.add('is-open');
    offer.setAttribute('aria-hidden', 'false');
    offerTrigger?.setAttribute('aria-expanded', 'true');
    body.classList.add('muse-offer-active');
    showOverlay();
    lock();
    window.requestAnimationFrame(() => {
      if (offer.classList.contains('is-open')) offer.querySelector('[data-offer-close]')?.focus({ preventScroll: true });
    });
    // Hiding the focused teaser can blur it after the opening frame.
    window.setTimeout(() => {
      if (offer.classList.contains('is-open') && !offer.contains(document.activeElement)) {
        offer.querySelector('[data-offer-close]')?.focus({ preventScroll: true });
      }
    }, 200);
  }
  function closeOffer() {
    dismissOfferTimer();
    const wasOpen = offer?.classList.contains('is-open');
    offer?.classList.remove('is-open');
    body.classList.remove('muse-offer-active');
    offerTrigger?.setAttribute('aria-expanded', 'false');
    if (wasOpen && offerReturnFocus?.isConnected) offerReturnFocus.focus({ preventScroll: true });
    if (offer) {
      offer.inert = true;
      offer.setAttribute('aria-hidden', 'true');
    }
    hideOverlay();
    unlock();
  }
  offerTrigger?.addEventListener('click', openOffer);
  document.querySelectorAll('[data-offer-close]').forEach((button) => button.addEventListener('click', closeOffer));
  document.querySelector('[data-offer-dismiss]')?.addEventListener('click', () => {
    dismissOfferTimer();
    offerTeaser?.setAttribute('hidden', '');
    sessionStorage.setItem('muse-offer-teaser-hidden', '1');
  });
  if (offerTeaser && sessionStorage.getItem('muse-offer-teaser-hidden') === '1') offerTeaser.hidden = true;
  offer?.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const controls = [...offer.querySelectorAll('button, input:not([type="hidden"]), select, textarea, a[href], [tabindex="0"]')]
      .filter(element => !element.disabled && !element.closest('[hidden], [inert]'));
    if (document.activeElement === (event.shiftKey ? controls[0] : controls.at(-1))) {
      event.preventDefault();
      (event.shiftKey ? controls.at(-1) : controls[0])?.focus();
    }
  });
  document.addEventListener('focusin', (event) => {
    if (offer?.classList.contains('is-open') && !offer.contains(event.target)) offer.querySelector('[data-offer-close]')?.focus({ preventScroll: true });
  });
  function showOfferSuccess() {
    dismissOfferTimer();
    if (offerClientError) {
      offerClientError.hidden = true;
      offerClientError.textContent = '';
    }
    if (offerSuccessMessage) {
      offerSuccessMessage.hidden = false;
      offerSuccessMessage.textContent = 'Success! Your extra 5% discount is ready and will be applied automatically at checkout.';
    }
    offer?.classList.add('has-success');
    window.sessionStorage.setItem('muse-offer-email-success', '1');
    document.querySelectorAll('.h-captcha, [data-hcaptcha-widget-id], iframe[src*="hcaptcha.com"], .shopify-challenge__container').forEach((element) => {
      element.setAttribute('hidden', '');
      element.style.setProperty('display', 'none', 'important');
    });
  }
  offerForm?.addEventListener('submit', async (event) => {
    const email = offerForm.querySelector('input[type="email"]');
    if (email && !email.checkValidity()) return;
    event.preventDefault();
    if (offerForm.dataset.offerSubmitting === 'true') return;
    offerForm.dataset.offerSubmitting = 'true';
    if (offerClientError) {
      offerClientError.hidden = true;
      offerClientError.textContent = '';
    }
    const previousSubmitText = offerSubmit?.textContent;
    if (offerSubmit) {
      offerSubmit.disabled = true;
      offerSubmit.textContent = 'Submitting...';
    }
    try {
      showOfferSuccess();
    } catch (error) {
      // The discount is automatic at checkout; email collection failures must not block the success state.
    } finally {
      offerForm.dataset.offerSubmitting = 'false';
      if (offerSubmit) {
        offerSubmit.disabled = false;
        offerSubmit.textContent = previousSubmitText || 'Continue';
      }
    }
  });
  if (offer?.querySelector('.muse-offer-success, .errors, [data-offer-errors]')) openOffer();
  else if (offer && sessionStorage.getItem('muse-offer-seen') !== '1' && sessionStorage.getItem('muse-offer-teaser-hidden') !== '1') {
    offerTimer = window.setTimeout(() => {
      if (sessionStorage.getItem('muse-offer-seen') !== '1' && !body.classList.contains('muse-lock') && !document.querySelector('dialog[open]')) openOffer();
    }, 10000);
  }
  offerScale();
  window.addEventListener('resize', offerScale, { passive: true });

  let searchTimer;
  let searchController;
  let searchVersion = 0;
  const searchInput = document.querySelector('[data-predictive-search]');
  const searchResults = document.querySelector('[data-search-results]');
  const resetSearch = () => {
    window.clearTimeout(searchTimer);
    searchController?.abort();
    searchVersion++;
    if (searchResults) {
      searchResults.replaceChildren();
      searchResults.setAttribute('aria-busy', 'false');
    }
  };
  searchInput?.form?.addEventListener('reset', resetSearch);
  searchInput?.addEventListener('input', (event) => {
    resetSearch();
    const query = event.target.value.trim();
    const results = searchResults;
    if (!results || query.length < 2) return;
    const version = searchVersion;
    results.setAttribute('aria-busy', 'true');
    searchTimer = window.setTimeout(async () => {
      searchController = new AbortController();
      try {
        const url = `${config.predictiveSearchUrl}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const response = await fetch(url, { headers: { Accept: 'application/json' }, signal: searchController.signal });
        if (!response.ok) throw new Error('Search is temporarily unavailable.');
        const data = await response.json();
        if (version !== searchVersion) return;
        const products = data.resources?.results?.products || [];
        results.innerHTML = products.map((product) => `
          <a class="muse-search-result" href="${escapeHtml(product.url)}">
            ${product.image ? `<img src="${escapeHtml(product.image)}" alt="">` : '<span></span>'}
            <span><strong>${escapeHtml(product.title)}</strong><br>${money(Math.round(Number(product.price) * 100))}</span>
          </a>
        `).join('') || '<p>No results found</p>';
      } catch (error) {
        if (version === searchVersion && error.name !== 'AbortError') results.innerHTML = '<p>Search is temporarily unavailable.</p>';
      } finally {
        if (version === searchVersion) results.setAttribute('aria-busy', 'false');
      }
    }, 220);
  });

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  }

  async function getCart() {
    const response = await fetch(`${config.cartUrl}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  let cartWriteQueue = Promise.resolve();
  const queueCartWrite = (operation) => {
    const result = cartWriteQueue.then(operation);
    cartWriteQueue = result.catch(() => {});
    return result;
  };
  async function postCart(url, data) {
    let response;
    let cart;
    try {
      response = await fetch(`${url}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data),
      });
      cart = await response.json();
    } catch {
      const error = new Error('Unable to confirm your cart changes. Please try again.');
      error.cartUncertain = true;
      throw error;
    }
    if (!response.ok || !Array.isArray(cart.items)) {
      const error = new Error(cart.description || cart.message || 'Unable to save your cart. Please try again.');
      error.cartUncertain = response.status >= 500 || response.ok;
      throw error;
    }
    return cart;
  }
  let drawerUpdating = false;

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
    const content = document.querySelector('[data-cart-content]');
    if (!content) return;
    if (!cart.items.length) {
      content.innerHTML = '<div class="muse-empty-cart"><p>Your cart is empty</p><a class="muse-button" href="/collections/best-selling">Continue shopping</a></div>';
      return;
    }
    const lines = cart.items.map((item) => `
      <div class="muse-cart-line" data-cart-line="${escapeHtml(item.key)}">
        <a href="${item.url}"><img src="${item.image || ''}${String(item.image || '').includes('?') ? '&' : '?'}width=240" alt="${escapeHtml(item.product_title)}"></a>
        <div class="muse-cart-line__info">
          <a class="muse-cart-line__title" href="${item.url}">${escapeHtml(item.product_title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="muse-cart-line__variant">${escapeHtml(item.variant_title)}</span>` : ''}
          <strong>${money(item.final_line_price)}</strong>
          <div class="muse-quantity">
            <button type="button" data-cart-quantity="${escapeHtml(item.key)}" data-value="${Math.max(1, item.quantity - 1)}" aria-label="Decrease quantity" ${item.quantity <= 1 ? 'disabled' : ''}>-</button>
            <input value="${item.quantity}" readonly aria-label="Quantity">
            <button type="button" data-cart-quantity="${escapeHtml(item.key)}" data-value="${item.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
          <button type="button" class="muse-link-button" data-cart-quantity="${escapeHtml(item.key)}" data-value="0">Remove</button>
        </div>
      </div>
    `).join('');
    content.innerHTML = `
      <div class="muse-cart-lines">${lines}</div>
      <div class="muse-cart-summary">
        <div class="muse-cart-summary__row"><span>Subtotal</span><span>${money(cart.total_price)}</span></div>
        <p>Taxes and shipping calculated at checkout</p>
        <form action="${config.cartUrl}" method="post"><button class="muse-button" type="submit" name="checkout">Checkout</button></form>
      </div>
    `;
  }

  async function refreshCart() {
    await cartWriteQueue;
    const cart = await getCart();
    renderCart(cart);
    return cart;
  }

  async function openCart() {
    closeAll();
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawerReturnFocus.set(drawer, document.activeElement);
    drawer.inert = false;
    drawer?.classList.add('is-open');
    drawer?.setAttribute('aria-hidden', 'false');
    showOverlay();
    lock();
    drawer.querySelector('[data-cart-close]')?.focus({ preventScroll: true });
    try { await refreshCart(); } catch { /* Keep server-rendered cart fallback. */ }
  }

  document.addEventListener('click', async (event) => {
    if (event.target.closest('[data-cart-open]')) {
      event.preventDefault();
      if (cartType === 'page') window.location.assign(config.cartUrl);
      else openCart();
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      closeAll();
      return;
    }
    const quantity = event.target.closest('[data-cart-quantity]');
    if (quantity) {
      if (drawerUpdating || quantity.disabled) return;
      drawerUpdating = true;
      const content = quantity.closest('[data-cart-content]');
      const controls = [...(content?.querySelectorAll('button') || [])].map(button => [button, button.disabled]);
      controls.forEach(([button]) => { button.disabled = true; });
      content?.querySelector('[data-cart-drawer-error]')?.remove();
      try {
        renderCart(await queueCartWrite(() => postCart(config.cartChangeUrl, { id: quantity.dataset.cartQuantity, quantity: Number(quantity.dataset.value) })));
      } catch (error) {
        const message = document.createElement('p');
        message.setAttribute('role', 'alert');
        message.setAttribute('data-cart-drawer-error', '');
        message.textContent = error.message || 'Unable to update quantity. Please try again.';
        content?.prepend(message);
      } finally {
        drawerUpdating = false;
        controls.forEach(([button, disabled]) => { button.disabled = disabled; });
      }
    }
  });

  document.addEventListener('submit', async (event) => {
    if (drawerUpdating && event.target.closest('[data-cart-drawer]')) { event.preventDefault(); return; }
    const form = event.target.closest('[data-product-form]');
    if (!form || event.submitter?.name === 'checkout' || event.submitter?.closest('.shopify-payment-button, shopify-accelerated-checkout')) return;
    event.preventDefault();
    const submit = event.submitter || form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    try {
      const response = await fetch(`${config.cartAddUrl}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error((await response.json()).description || 'Unable to add product');
      if (cartType === 'page') {
        window.location.assign(config.cartUrl);
        return;
      }
      await openCart();
    } catch (error) {
      const errorBox = form.querySelector('[data-product-error]');
      if (errorBox) errorBox.textContent = error.message;
    } finally {
      if (submit) submit.disabled = false;
    }
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const json = root.querySelector('[data-product-json]');
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const selected = new Map();
    root.querySelectorAll('[data-option-group]').forEach((group) => {
      const select = group.querySelector('[data-option-select]');
      const checked = group.querySelector('[data-option-value][aria-pressed="true"]') || group.querySelector('[data-option-value]');
      if (select) selected.set(group.dataset.optionGroup, select.value);
      else if (checked) selected.set(group.dataset.optionGroup, checked.dataset.optionValue);
    });

    const quantityInput = root.querySelector('[data-product-quantity]');
    const readQuantity = () => {
      const quantity = Number(quantityInput?.value);
      return Number.isSafeInteger(quantity) && quantity >= 1 ? quantity : 1;
    };
    const updateTotal = (variant) => {
      if (!variant) return;
      root.querySelectorAll('[data-product-total]').forEach((element) => { element.textContent = money(variant.price * readQuantity()); });
    };
    let currentVariant;
    const updateVariant = () => {
      const variant = product.variants.find((entry) => entry.options.every((value, index) => selected.get(product.options[index]) === value));
      if (!variant) return;
      currentVariant = variant;
      root.querySelectorAll('input[name="id"]').forEach((input) => { input.value = variant.id; });
      root.querySelectorAll('[data-product-price]').forEach((element) => { element.textContent = money(variant.price); });
      root.querySelectorAll('[data-product-compare]').forEach((element) => {
        element.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
        element.hidden = !(variant.compare_at_price > variant.price);
      });
      root.querySelectorAll('[data-product-savings]').forEach((element) => {
        const percent = variant.compare_at_price > variant.price ? Math.round((1 - variant.price / variant.compare_at_price) * 100) : 0;
        element.textContent = percent ? `Save ${percent}%` : '';
        element.hidden = !(variant.compare_at_price > variant.price);
      });
      root.querySelectorAll('[data-add-to-cart]').forEach((button) => {
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to cart' : 'Sold out';
      });
      updateTotal(variant);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    };
    const syncOptionControls = () => {
      root.querySelectorAll('[data-option-group]').forEach((group) => {
        const value = selected.get(group.dataset.optionGroup);
        if (!value) return;
        const label = group.querySelector('[data-selected-option]');
        if (label) label.textContent = value;
        const select = group.querySelector('[data-option-select]');
        if (select) select.value = value;
        const sizeLabel = group.querySelector('[data-size-label]');
        if (sizeLabel) sizeLabel.textContent = value;
        group.querySelectorAll('[data-size-value]').forEach((button) => {
          button.setAttribute('aria-selected', String(button.dataset.sizeValue === value));
        });
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.optionValue === value));
        });
      });
    };
    const applyDefaultWoodFrame = () => {
      if (new URL(window.location.href).searchParams.has('variant')) return;
      const frameIndex = product.options.findIndex((name, index) => (
        /canvas or frame/i.test(String(name || '')) ||
        (
          /canvas|frame/i.test(String(name || '')) &&
          product.variants.some((variant) => variant.options?.[index] === 'Wood Frame')
        )
      ));
      if (frameIndex < 0) return;
      const optionName = product.options[frameIndex];
      if (!product.variants.some((variant) => variant.options?.[frameIndex] === 'Wood Frame')) return;
      selected.set(optionName, 'Wood Frame');
      const exactVariant = product.variants.find((entry) => entry.available && entry.options.every((value, index) => selected.get(product.options[index]) === value))
        || product.variants.find((entry) => entry.options.every((value, index) => selected.get(product.options[index]) === value));
      const fallbackVariant = product.variants.find((entry) => entry.available && entry.options?.[frameIndex] === 'Wood Frame')
        || product.variants.find((entry) => entry.options?.[frameIndex] === 'Wood Frame');
      const targetVariant = exactVariant || fallbackVariant;
      if (!targetVariant) return;
      product.options.forEach((name, index) => selected.set(name, targetVariant.options[index]));
      syncOptionControls();
      updateVariant();
    };
    applyDefaultWoodFrame();

    root.querySelectorAll('[data-option-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const group = select.closest('[data-option-group]');
        selected.set(group.dataset.optionGroup, select.value);
        const label = group.querySelector('[data-selected-option]');
        if (label) label.textContent = select.value;
        updateVariant();
      });
    });

    root.querySelectorAll('[data-size-picker]').forEach((picker) => {
      const select = picker.querySelector('[data-option-select]');
      const toggle = picker.querySelector('[data-size-toggle]');
      const list = picker.querySelector('[data-size-list]');
      const options = [...list.querySelectorAll('[data-size-value]')];
      const setOpen = (open, focus = false) => {
        list.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        if (focus) (open ? options.find(option => option.dataset.sizeValue === select.value) : toggle)?.focus();
      };
      picker.classList.add('is-enhanced');
      toggle.hidden = false;
      toggle.addEventListener('click', () => setOpen(list.hidden, true));
      picker.addEventListener('click', (event) => {
        const option = event.target.closest('[data-size-value]');
        if (!option) return;
        select.value = option.dataset.sizeValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        setOpen(false, true);
      });
      select.addEventListener('change', () => {
        picker.querySelector('[data-size-label]').textContent = select.value;
        options.forEach(option => option.setAttribute('aria-selected', String(option.dataset.sizeValue === select.value)));
      });
      picker.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { setOpen(false, true); event.preventDefault(); return; }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (list.hidden) { setOpen(true, true); return; }
        const current = options.indexOf(document.activeElement);
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : (current + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options[index]?.focus();
      });
      document.addEventListener('click', (event) => { if (!picker.contains(event.target)) setOpen(false); });
      picker.addEventListener('focusout', (event) => { if (!picker.contains(event.relatedTarget)) setOpen(false); });
    });

    root.addEventListener('click', (event) => {
      const stickyAdd = event.target.closest('[data-sticky-add]');
      if (stickyAdd) {
        event.preventDefault();
        root.querySelector('.muse-product-form [data-add-to-cart]')?.click();
        return;
      }
      const option = event.target.closest('[data-option-value]');
      if (option) {
        const group = option.closest('[data-option-group]');
        group.querySelectorAll('[data-option-value]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
        option.setAttribute('aria-pressed', 'true');
        selected.set(group.dataset.optionGroup, option.dataset.optionValue);
        const label = group.querySelector('[data-selected-option]');
        if (label) label.textContent = option.dataset.optionValue;
        updateVariant();
      }
      const quantityButton = event.target.closest('[data-quantity-change]');
      if (quantityButton) {
        const input = root.querySelector('[data-product-quantity]');
        input.value = Math.max(1, Math.min(Number.MAX_SAFE_INTEGER, readQuantity() + Number(quantityButton.dataset.quantityChange)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    quantityInput?.addEventListener('input', () => updateTotal(currentVariant));
    quantityInput?.addEventListener('change', () => {
      quantityInput.value = readQuantity();
      updateTotal(currentVariant);
    });
    const stickyPurchase = root.querySelector('[data-sticky-purchase]');
    const primaryForm = root.querySelector('[data-product-form]');
    const footer = document.querySelector('.muse-footer');
    if (stickyPurchase && primaryForm && 'IntersectionObserver' in window) {
      let belowForm = false;
      let footerVisible = false;
      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === primaryForm) belowForm = entry.boundingClientRect.bottom < 0;
          if (entry.target === footer) footerVisible = entry.isIntersecting;
        }
        const visible = belowForm && !footerVisible;
        stickyPurchase.classList.toggle('is-visible', visible);
        stickyPurchase.inert = !visible;
      });
      observer.observe(primaryForm);
      if (footer) observer.observe(footer);
    }
    updateVariant();
  });

  document.querySelectorAll('[data-description-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const description = button.previousElementSibling;
      const expanded = description?.classList.toggle('is-expanded');
      button.textContent = expanded ? 'Read less' : 'Read more';
    });
  });

  const reviewSection = document.querySelector('[data-review-section]');
  const reviewPhotoDialog = reviewSection?.querySelector('[data-review-photo-dialog]');
  const reviewPhotoContent = reviewPhotoDialog?.querySelector('[data-review-photo-content]');
  let reviewPhotoTrigger;
  reviewSection?.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-review-photo-open]');
    if (!trigger || !reviewPhotoDialog || reviewPhotoDialog.open) return;
    const card = trigger.closest('.muse-review-card');
    const image = trigger.querySelector('img')?.cloneNode(true);
    const details = card?.querySelector(':scope > div')?.cloneNode(true);
    if (!image || !details || typeof reviewPhotoDialog.showModal !== 'function') return;
    closeAll();
    reviewPhotoTrigger = trigger;
    const previewSource = image.src;
    image.addEventListener('error', () => { image.src = previewSource; }, { once: true });
    const url = new URL(image.src, window.location.href);
    url.searchParams.set('width', '1400');
    image.src = url.href;
    image.removeAttribute('srcset');
    image.loading = 'eager';
    details.className = 'muse-review-photo__details';
    reviewPhotoContent.replaceChildren(image, details);
    reviewPhotoDialog.showModal();
    document.documentElement.classList.add('muse-review-photo-open');
    reviewPhotoDialog.querySelector('[data-review-photo-close]')?.focus({ preventScroll: true });
  });
  reviewPhotoDialog?.querySelector('[data-review-photo-close]')?.addEventListener('click', () => reviewPhotoDialog.close());
  reviewPhotoDialog?.addEventListener('click', (event) => {
    if (event.target !== reviewPhotoDialog) return;
    const bounds = reviewPhotoDialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) reviewPhotoDialog.close();
  });
  reviewPhotoDialog?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') event.stopPropagation();
  });
  reviewPhotoDialog?.addEventListener('close', () => {
    document.documentElement.classList.remove('muse-review-photo-open');
    reviewPhotoContent.replaceChildren();
    if (reviewPhotoTrigger?.isConnected) reviewPhotoTrigger.focus({ preventScroll: true });
    reviewPhotoTrigger = null;
  });
  const reviewModal = reviewSection?.querySelector('[data-review-modal]');
  const reviewRatingStep = reviewModal?.querySelector('[data-review-rating-step]');
  const reviewFormStep = reviewModal?.querySelector('[data-review-form-step]');
  const reviewScroll = reviewModal?.querySelector('[data-review-scroll]');
  const fitReviewViewport = () => {
    if (!reviewModal?.classList.contains('is-open')) return;
    reviewModal.style.setProperty('--muse-review-viewport-height', `${window.visualViewport?.height || window.innerHeight}px`);
    reviewModal.style.setProperty('--muse-review-viewport-top', `${window.visualViewport?.offsetTop || 0}px`);
  };
  window.visualViewport?.addEventListener('resize', fitReviewViewport, { passive: true });
  window.visualViewport?.addEventListener('scroll', fitReviewViewport, { passive: true });
  window.addEventListener('resize', fitReviewViewport, { passive: true });
  let reviewReturnFocus;
  let reviewStepTimer;
  let reviewLayoutFrame;
  const layoutReviewCards = () => {
    const grid = reviewSection?.querySelector('[data-review-grid]');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('.muse-review-card:not([hidden])'));
    const columns = window.matchMedia('(max-width: 699px)').matches ? 2 : window.matchMedia('(max-width: 1149px)').matches ? 4 : 5;
    const columnWidth = grid.clientWidth / columns;
    const columnHeights = Array(columns).fill(0);
    cards.forEach((card) => {
      card.style.width = `${Math.max(1, columnWidth - 14)}px`;
      card.style.left = '0';
      card.style.top = '0';
    });
    cards.forEach((card) => {
      const column = columnHeights.indexOf(Math.min(...columnHeights));
      const top = columnHeights[column] + 7;
      card.style.left = `${column * columnWidth + 7}px`;
      card.style.top = `${top}px`;
      columnHeights[column] += card.getBoundingClientRect().height + 14;
    });
    grid.style.height = `${Math.max(...columnHeights, 0) + 20}px`;
  };
  const scheduleReviewLayout = () => {
    window.cancelAnimationFrame(reviewLayoutFrame);
    reviewLayoutFrame = window.requestAnimationFrame(() => window.requestAnimationFrame(layoutReviewCards));
  };
  const reviewGrid = reviewSection?.querySelector('[data-review-grid]');
  const reviewResizeObserver = reviewGrid && 'ResizeObserver' in window
    ? new ResizeObserver(scheduleReviewLayout)
    : null;
  reviewResizeObserver?.observe(reviewGrid);
  reviewSection?.querySelectorAll('img').forEach((image) => {
    if (!image.complete) image.addEventListener('load', scheduleReviewLayout, { once: true });
  });
  document.fonts?.ready.then(scheduleReviewLayout);
  window.addEventListener('resize', scheduleReviewLayout, { passive: true });
  scheduleReviewLayout();
  const openReviewModal = () => {
    if (!reviewModal) return;
    closeAll();
    reviewReturnFocus = document.activeElement;
    reviewModal.inert = false;
    reviewModal.classList.add('is-open');
    reviewModal.setAttribute('aria-hidden', 'false');
    fitReviewViewport();
    showOverlay();
    lock();
    window.requestAnimationFrame(() => {
      if (reviewModal.classList.contains('is-open')) reviewModal.querySelector('[data-review-close]')?.focus({ preventScroll: true });
    });
  };
  const closeReviewModal = () => {
    if (!reviewModal) return;
    reviewModal.classList.remove('is-open');
    reviewModal.setAttribute('aria-hidden', 'true');
    hideOverlay();
    unlock();
    reviewModal.dispatchEvent(new Event('muse:review-closed'));
  };
  reviewModal?.addEventListener('muse:review-closed', () => {
    window.clearTimeout(reviewStepTimer);
    reviewModal.inert = true;
    if (reviewReturnFocus?.isConnected) reviewReturnFocus.focus({ preventScroll: true });
  });
  reviewModal?.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const controls = [...reviewModal.querySelectorAll('button, input:not([type="hidden"]), textarea, a[href]')]
      .filter(element => !element.disabled && !element.closest('[hidden]'));
    const boundary = event.shiftKey ? controls[0] : controls.at(-1);
    if (document.activeElement === boundary) {
      event.preventDefault();
      (event.shiftKey ? controls.at(-1) : controls[0])?.focus();
    }
  });
  document.addEventListener('focusin', (event) => {
    if (reviewModal?.classList.contains('is-open') && !reviewModal.contains(event.target)) {
      reviewModal.querySelector('[data-review-close]')?.focus({ preventScroll: true });
    }
  });
  reviewSection?.querySelector('[data-review-open]')?.addEventListener('click', openReviewModal);
  reviewSection?.querySelector('[data-review-close]')?.addEventListener('click', closeReviewModal);
  reviewSection?.querySelectorAll('[data-review-rate]').forEach((button) => {
    button.addEventListener('click', () => {
      const rating = Number(button.dataset.reviewRate);
      reviewSection.querySelector('[data-review-rating-input]').value = String(rating);
      const ratingLabel = reviewSection.querySelector('[data-review-rating-label]');
      if (ratingLabel) ratingLabel.textContent = String(rating);
      reviewSection.querySelectorAll('[data-review-rate]').forEach((star) => star.classList.toggle('is-selected', Number(star.dataset.reviewRate) <= rating));
      window.clearTimeout(reviewStepTimer);
      reviewStepTimer = window.setTimeout(() => {
        if (!reviewModal.classList.contains('is-open')) return;
        reviewRatingStep.hidden = true;
        reviewFormStep.hidden = false;
        if (reviewScroll) reviewScroll.scrollTop = 0;
        reviewFormStep.querySelector('input:not([type="hidden"])')?.focus();
      }, 180);
    });
  });
  reviewSection?.querySelector('[data-review-edit-rating]')?.addEventListener('click', () => {
    window.clearTimeout(reviewStepTimer);
    reviewFormStep.hidden = true;
    reviewRatingStep.hidden = false;
    if (reviewScroll) reviewScroll.scrollTop = 0;
    const rating = reviewSection.querySelector('[data-review-rating-input]').value;
    reviewSection.querySelector(`[data-review-rate="${rating}"]`)?.focus();
  });
  reviewSection?.querySelectorAll('[data-review-tab]').forEach((button) => {
    button.addEventListener('click', () => {
      const kind = button.dataset.reviewTab;
      reviewSection.querySelectorAll('[data-review-tab]').forEach((tab) => {
        if (tab.getAttribute('role') === 'tab') tab.setAttribute('aria-selected', String(tab.dataset.reviewTab === kind));
      });
      reviewSection.querySelectorAll('[data-review-kind]').forEach((card) => { card.hidden = card.dataset.reviewKind !== kind; });
      const summary = reviewSection.querySelector('[data-review-summary]');
      if (summary) summary.hidden = kind !== 'product';
      const empty = reviewSection.querySelector('[data-review-empty]');
      if (empty) empty.hidden = kind !== 'product';
      scheduleReviewLayout();
    });
  });
  const reviewSortDetails = reviewSection?.querySelector('.muse-reviews__sort');
  const reviewSortSummary = reviewSortDetails?.querySelector('summary');
  const toggleReviewSort = (event) => {
    event.preventDefault();
    reviewSortDetails.open = !reviewSortDetails.open;
  };
  reviewSortSummary?.addEventListener('click', toggleReviewSort);
  reviewSortSummary?.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') toggleReviewSort(event);
  });
  reviewSection?.querySelectorAll('[data-review-sort]').forEach((button) => {
    button.addEventListener('click', () => {
      const grid = reviewSection.querySelector('[data-review-grid]');
      const cards = Array.from(grid.querySelectorAll('[data-review-kind="product"]'));
      const mode = button.dataset.reviewSort;
      cards.sort((left, right) => {
        if (mode === 'newest') return right.dataset.reviewDate.localeCompare(left.dataset.reviewDate);
        if (mode === 'highest') return Number(right.dataset.reviewRating) - Number(left.dataset.reviewRating);
        if (mode === 'lowest') return Number(left.dataset.reviewRating) - Number(right.dataset.reviewRating);
        return Number(left.dataset.reviewFeatured) - Number(right.dataset.reviewFeatured);
      });
      cards.forEach((card) => grid.append(card));
      button.closest('details')?.removeAttribute('open');
      scheduleReviewLayout();
    });
  });
  if (reviewSection?.querySelector('.muse-review-success')) {
    reviewRatingStep.hidden = true;
    reviewFormStep.hidden = false;
    openReviewModal();
  }

  document.querySelectorAll('.muse-product-gallery').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;
    const panels = [...track.querySelectorAll('[data-gallery-panel]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const thumbTrack = gallery.querySelector('[data-carousel-track]');
    const zoomButton = gallery.querySelector('[data-gallery-zoom]');
    const stage = gallery.querySelector('.muse-product-gallery__stage');
    const cursor = gallery.querySelector('[data-gallery-cursor]');
    const arrows = [...gallery.querySelectorAll('[data-gallery-step]')];
    const desktopNavigation = () => window.matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)').matches;
    let activeIndex = 0;
    let scrollFrame;
    const activate = (index) => {
      activeIndex = Math.max(0, Math.min(panels.length - 1, index));
      panels.forEach((panel, i) => {
        const active = i === activeIndex;
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
        const player = panel.querySelector('[data-media-player]');
        if (player && active && !player.childElementCount) player.append(panel.querySelector('template').content.cloneNode(true));
        if (player && !active) player.replaceChildren();
        if (!active) panel.querySelector('video')?.pause();
      });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === activeIndex)));
      if (zoomButton) zoomButton.hidden = panels[activeIndex]?.dataset.mediaType !== 'image';
      const isImage = panels[activeIndex]?.dataset.mediaType === 'image';
      track.dataset.galleryClickNavigation = String(panels.length > 1 && isImage && desktopNavigation());
      arrows.forEach((arrow) => {
        arrow.hidden = !isImage;
        arrow.disabled = Number(arrow.dataset.galleryStep) < 0 ? activeIndex === 0 : activeIndex === panels.length - 1;
      });
      if (!isImage) cursor?.classList.remove('is-visible');
    };
    const select = (index) => {
      activate(index);
      track.scrollTo({ left: activeIndex * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      const thumb = thumbs[activeIndex];
      if (thumbTrack && thumb) {
        const bounds = thumb.getBoundingClientRect();
        const viewport = thumbTrack.getBoundingClientRect();
        const offset = bounds.left < viewport.left ? bounds.left - viewport.left : bounds.right > viewport.right ? bounds.right - viewport.right : 0;
        if (offset) thumbTrack.scrollBy({ left: offset, behavior: 'smooth' });
      }
    };
    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) select(Number(thumb.dataset.galleryIndex));
      const arrow = event.target.closest('[data-gallery-step]');
      if (arrow && !arrow.disabled) select(activeIndex + Number(arrow.dataset.galleryStep));
    });
    const navigationDirection = (event) => event.clientX - track.getBoundingClientRect().left < track.clientWidth / 2 ? -1 : 1;
    track.addEventListener('pointermove', (event) => {
      if (!cursor || !desktopNavigation() || track.dataset.galleryClickNavigation !== 'true') return;
      const bounds = stage.getBoundingClientRect();
      stage.style.setProperty('--gallery-cursor-x', `${event.clientX - bounds.left}px`);
      stage.style.setProperty('--gallery-cursor-y', `${event.clientY - bounds.top}px`);
      cursor.dataset.direction = navigationDirection(event) < 0 ? 'previous' : 'next';
      cursor.classList.add('is-visible');
    });
    track.addEventListener('pointerleave', () => cursor?.classList.remove('is-visible'));
    track.addEventListener('click', (event) => {
      if (!desktopNavigation() || track.dataset.galleryClickNavigation !== 'true') return;
      if (event.target.closest('a, button, video, iframe, [data-media-player]')) return;
      select(activeIndex + navigationDirection(event));
    });
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => activate(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
    }, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || event.target !== track) return;
      event.preventDefault();
      select(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    window.addEventListener('resize', () => {
      track.scrollTo({ left: activeIndex * track.clientWidth, behavior: 'instant' });
      activate(activeIndex);
    }, { passive: true });
    activate(0);
    let photoSwipeModule;
    zoomButton?.addEventListener('click', async () => {
      if (zoomButton.disabled) return;
      zoomButton.disabled = true;
      const imagePanels = panels.filter(panel => panel.dataset.mediaType === 'image');
      const index = imagePanels.indexOf(panels[activeIndex]);
      if (index < 0) { zoomButton.disabled = false; return; }
      try {
        photoSwipeModule ||= import(gallery.dataset.photoswipeModule).catch(error => { photoSwipeModule = null; throw error; });
        const { default: PhotoSwipe } = await photoSwipeModule;
        const lightbox = new PhotoSwipe({
          dataSource: imagePanels.map(panel => ({ src: panel.dataset.gallerySrc, width: Number(panel.dataset.galleryWidth), height: Number(panel.dataset.galleryHeight), alt: panel.querySelector('img')?.alt || '' })),
          index, bgOpacity: 1, maxZoomLevel: 3, showHideAnimationType: 'fade',
          arrowPrev: false, arrowNext: false, counter: false, zoom: false,
          closeTitle: 'Close gallery',
          closeSVG: '<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56"><path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/><path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/><path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/></svg>',
        });
        lightbox.on('uiRegister', () => lightbox.ui.registerElement({
          name: 'bottom-bar', order: 5, appendTo: 'wrapper',
          html: '<div class="pagination"><button type="button" class="pagination__item group" rel="prev" aria-label="Previous image"><span class="animated-arrow animated-arrow--reverse"></span></button><span class="pagination__current text-sm"><span class="pagination__current-page">1</span> / <span class="pagination__page-count"></span></span><button type="button" class="pagination__item group" rel="next" aria-label="Next image"><span class="animated-arrow"></span></button></div>',
          onInit: (element, pswp) => {
            element.querySelector('.pagination__page-count').textContent = String(pswp.getNumItems());
            element.querySelector('[rel="prev"]').addEventListener('click', () => pswp.prev());
            element.querySelector('[rel="next"]').addEventListener('click', () => pswp.next());
            pswp.on('change', () => { element.querySelector('.pagination__current-page').textContent = String(pswp.currIndex + 1); });
          },
        }));
        lightbox.on('change', () => select(panels.indexOf(imagePanels[lightbox.currIndex])));
        lightbox.on('destroy', () => zoomButton.focus());
        lightbox.init();
      } catch {
        const root = gallery.closest('[data-product-root]');
        const lightbox = root.querySelector('[data-image-lightbox]');
        lightbox.querySelector('img').src = imagePanels[index].dataset.gallerySrc;
        lightbox.querySelector('img').alt = imagePanels[index].querySelector('img')?.alt || '';
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        lock();
      } finally { zoomButton.disabled = false; }
    });
  });
  document.querySelectorAll('[data-image-lightbox-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const lightbox = button.closest('[data-image-lightbox]');
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      unlock();
    });
  });

  const collectionFilter = document.querySelector('[data-collection-filter]');
  const openCollectionFilter = () => {
    collectionFilter?.classList.add('is-open');
    showOverlay();
    lock();
  };
  const closeCollectionFilter = () => {
    collectionFilter?.classList.remove('is-open');
    hideOverlay();
    unlock();
  };
  document.querySelectorAll('[data-collection-filter-open]').forEach((button) => button.addEventListener('click', openCollectionFilter));
  document.querySelector('[data-collection-filter-close]')?.addEventListener('click', closeCollectionFilter);

  const cartPage = document.querySelector('[data-cart-page]');
  const cartForm = cartPage?.querySelector('[data-cart-page-form]');
  if (cartForm) {
    const initialCart = JSON.parse(cartPage.querySelector('[data-cart-page-state]').textContent);
    const note = cartForm.querySelector('[data-cart-note]');
    const errorBox = cartForm.querySelector('[data-cart-error]');
    const status = cartForm.querySelector('[data-cart-status]');
    const urgency = cartPage.querySelector('[data-cart-urgency]');
    const entries = [...cartPage.querySelectorAll('[data-cart-page-line]')].map(row => {
      const item = initialCart.items.find(item => item.key === row.dataset.cartKey);
      return { row, item, inputs: [...row.querySelectorAll('[data-cart-page-quantity]')], desired: String(item.quantity), confirmed: item.quantity, remove: false };
    });
    let confirmedNote = initialCart.note || '';
    let saving;
    let noteTimer;
    let checkoutPending = false;
    let checkoutReady = false;
    let saveFailed = false;
    let quantityError = false;
    let cartNeedsReview = false;
    const setError = (message = '') => {
      if (cartNeedsReview) message = 'We could not confirm your cart contents. Keep a copy of any unsaved note and reload this page before checkout.';
      errorBox.textContent = message;
      errorBox.hidden = !message;
    };
    const syncInputs = (entry) => entry.inputs.forEach(input => { input.value = entry.desired; });
    const validate = () => {
      let valid = true;
      entries.filter(entry => entry.confirmed > 0 && !entry.remove).forEach(entry => {
        if (!/^\d+$/.test(entry.desired) || !Number.isSafeInteger(Number(entry.desired)) || Number(entry.desired) < 1) {
          entry.desired = String(entry.confirmed);
          syncInputs(entry);
          valid = false;
        }
      });
      if (!valid) {
        quantityError = true;
        setError('Enter a whole number of 1 or more. Your previous quantity has been restored.');
      }
      return valid;
    };
    const title = (application) => application.title === 'GET40OFF' ? 'Late Summer Home Refresh 40% Off' : application.title;
    const tagIcon = cartPage.querySelector('[data-cart-line-discounts] .badge svg')?.outerHTML || '';
    const summaryIcon = cartPage.querySelector('[data-cart-discounts] svg')?.outerHTML || tagIcon;
    // Discount changes can replace line keys. Match the same variant/properties/plan, never its position.
    const identity = (item) => JSON.stringify([item.variant_id || item.id, Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b)), item.selling_plan_allocation?.selling_plan?.id || null]);
    const applyCart = (cart, changedEntry, requestedQuantity) => {
      const unclaimed = new Set(cart.items);
      const matches = new Map();
      const changedCartError = () => {
        cartNeedsReview = true;
        throw new Error('Your cart changed in another session. Reload this page to review it before checkout.');
      };
      entries.forEach(entry => {
        const item = cart.items.find(item => item.key === entry.item.key);
        if (item) { matches.set(entry, item); unclaimed.delete(item); }
      });
      entries.filter(entry => !matches.has(entry) && entry.confirmed > 0).forEach(entry => {
        const candidates = [...unclaimed].filter(item => identity(item) === identity(entry.item));
        const owners = entries.filter(other => other.confirmed > 0 && !matches.has(other) && identity(other.item) === identity(entry.item));
        if (candidates.length === 1 && owners.length === 1) { matches.set(entry, candidates[0]); unclaimed.delete(candidates[0]); }
        else if (!(entry === changedEntry && requestedQuantity === 0)) changedCartError();
      });
      if (unclaimed.size) changedCartError();
      entries.forEach(entry => {
        const item = matches.get(entry);
        const clean = entry.desired === String(entry.confirmed) || (entry === changedEntry && entry.desired === String(requestedQuantity));
        entry.confirmed = item?.quantity || 0;
        if (clean) entry.desired = String(entry.confirmed);
        entry.row.hidden = !item;
        if (!item) { entry.remove = false; return; }
        entry.item = item;
        entry.row.dataset.cartKey = item.key;
        entry.row.querySelectorAll('[data-cart-key]').forEach(element => { element.dataset.cartKey = item.key; });
        entry.row.querySelectorAll('[data-cart-page-remove]').forEach(link => { link.href = `${config.cartChangeUrl}?id=${encodeURIComponent(item.key)}&quantity=0`; });
        syncInputs(entry);
        entry.row.querySelector('[data-cart-line-total]').textContent = money(item.final_line_price);
        entry.row.querySelector('[data-cart-line-prices]').innerHTML = item.final_line_price < item.original_line_price
          ? `<sale-price class="text-on-sale"><span class="sr-only">Sale price</span>${money(item.final_line_price)}</sale-price><compare-at-price class="text-subdued line-through"><span class="sr-only">Regular price</span>${money(item.original_line_price)}</compare-at-price>`
          : `<sale-price><span class="sr-only">Price</span>${money(item.final_line_price)}</sale-price>`;
        const badges = (item.line_level_discount_allocations || []).map(allocation => `${escapeHtml(title(allocation.discount_application))} (-${money(allocation.amount)})`)
          .concat((cart.cart_level_discount_applications || []).map(application => escapeHtml(title(application))));
        entry.row.querySelector('[data-cart-line-discounts]').innerHTML = badges.length ? `<ul class="contents" role="list">${badges.map(badge => `<li class="badge">${tagIcon}${badge}</li>`).join('')}</ul>` : '';
      });
      confirmedNote = cart.note || '';
      const discounts = cart.cart_level_discount_applications || [];
      cartForm.querySelector('[data-cart-subtotal]').textContent = money(discounts.length ? cart.original_total_price : cart.total_price);
      cartForm.querySelector('[data-cart-total]').textContent = `${money(cart.total_price)} ${cart.currency || config.currency || 'USD'}`;
      cartForm.querySelector('[data-cart-discounts]').innerHTML = discounts.map(application => `<div class="h-stack gap-4 justify-between muse-cart-discount"><span class="text-with-icon">${summaryIcon}${escapeHtml(title(application))}</span><span>-${money(application.total_allocated_amount)}</span></div>`).join('');
      document.querySelectorAll('[data-cart-count]').forEach(count => { count.textContent = cart.item_count; });
      cartPage.querySelector('[data-cart-empty]').hidden = cart.item_count > 0;
      if (urgency) urgency.hidden = cart.item_count === 0;
      // Keep the note and any failure feedback accessible even when the last line is removed.
      cartForm.querySelector('[name="checkout"]').hidden = cart.item_count === 0;
    };
    const flush = () => {
      window.clearTimeout(noteTimer);
      if (saving) return saving;
      if (cartNeedsReview) return Promise.resolve(false);
      saveFailed = false;
      saving = Promise.resolve().then(async () => {
        cartForm.setAttribute('aria-busy', 'true');
        status.hidden = false;
        status.textContent = 'Saving changes...';
        try {
          while (true) {
            if (!validate()) { saveFailed = true; return false; }
            const entry = entries.find(entry => entry.confirmed > 0 && (entry.remove || Number(entry.desired) !== entry.confirmed));
            const noteValue = note.value;
            if (!entry && noteValue === confirmedNote) {
              const order = cartPage.querySelector('.cart-order');
              if (order) order.hidden = !entries.some(entry => entry.confirmed > 0);
              return true;
            }
            const quantity = entry?.remove ? 0 : Number(entry?.desired);
            try {
              const cart = await queueCartWrite(() => entry
                ? postCart(config.cartChangeUrl, { id: entry.item.key, quantity })
                : postCart(config.cartUpdateUrl || `${config.cartUrl}/update`, { note: noteValue }));
              applyCart(cart, entry, quantity);
              if (entry && entry.confirmed !== quantity) throw new Error('The requested quantity is not available. Your cart shows the available quantity.');
              if (!entry && confirmedNote !== noteValue) throw new Error('Your order note could not be saved. Please try again.');
            } catch (error) {
              // A lost response does not prove the write failed. Read back before restoring quantities.
              if (entry && error.cartUncertain) {
                try { applyCart(await getCart(), entry, quantity); }
                catch { cartNeedsReview = true; }
              }
              if (entry) {
                entry.desired = String(entry.confirmed);
                entry.remove = false;
                syncInputs(entry);
              }
              saveFailed = true;
              setError(error.message || 'Unable to save your cart. Please try again.');
              return false;
            }
          }
        } finally {
          cartForm.setAttribute('aria-busy', 'false');
          status.hidden = true;
          saving = null;
        }
      });
      return saving;
    };
    entries.forEach(entry => {
      entry.inputs.forEach(input => {
        input.addEventListener('input', () => {
          entry.desired = input.value;
          entry.remove = false;
          syncInputs(entry);
          quantityError = false;
          setError();
        });
        input.addEventListener('change', () => {
          entry.desired = input.value;
          syncInputs(entry);
          if (validate()) { quantityError = false; setError(); flush(); }
        });
      });
      entry.row.querySelectorAll('[data-cart-page-remove]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        if (checkoutPending) return;
        entry.remove = true;
        setError();
        flush();
      }));
    });
    note.addEventListener('input', () => {
      window.clearTimeout(noteTimer);
      setError();
      noteTimer = window.setTimeout(flush, 350);
    });
    note.addEventListener('change', flush);
    cartForm.addEventListener('submit', async event => {
      if (checkoutReady) return;
      event.preventDefault();
      if (checkoutPending) return;
      const submit = event.submitter || cartForm.querySelector('[name="checkout"]');
      if (!validate() || quantityError) {
        quantityError = false;
        errorBox.focus({ preventScroll: true });
        return;
      }
      checkoutPending = true;
      const controls = [...cartPage.querySelectorAll('[data-cart-page-quantity], [data-cart-note], [name="checkout"]')];
      const disabled = controls.map(control => control.disabled);
      controls.forEach(control => { control.disabled = true; });
      cartPage.querySelectorAll('[data-cart-page-remove]').forEach(link => link.setAttribute('aria-disabled', 'true'));
      const saved = await flush();
      const releaseCheckout = () => {
        controls.forEach((control, index) => { control.disabled = disabled[index]; });
        cartPage.querySelectorAll('[data-cart-page-remove]').forEach(link => link.removeAttribute('aria-disabled'));
        checkoutPending = false;
      };
      if (!saved || saveFailed) {
        releaseCheckout();
        quantityError = false;
        errorBox.focus({ preventScroll: true });
        return;
      }
      if (!entries.some(entry => entry.confirmed > 0)) { releaseCheckout(); return; }
      setError();
      // A microtask can still be inside the browser's original submit algorithm.
      // Re-enter in a new task so its firing-submission-events guard has cleared.
      window.setTimeout(() => {
        releaseCheckout();
        checkoutReady = true;
        try { cartForm.requestSubmit(submit); } finally { checkoutReady = false; }
      }, 0);
    });
  }

  document.querySelectorAll('[data-shipping-disclosure]').forEach((details) => {
    details.addEventListener('toggle', () => details.setAttribute('aria-expanded', String(details.open)));
  });

  document.querySelectorAll('[data-shipping-estimator]').forEach((form) => {
    const country = form.querySelector('[data-shipping-country]');
    const province = form.querySelector('[data-shipping-province]');
    const provinceWrap = form.querySelector('[data-shipping-province-wrap]');
    const results = form.parentElement.querySelector('[data-shipping-results]');
    const submit = form.querySelector('[type="submit"]');
    let requestVersion = 0;
    let shippingController;
    const addressKey = () => new URLSearchParams(new FormData(form)).toString();
    const invalidateRates = () => {
      requestVersion++;
      shippingController?.abort();
      results.hidden = true;
      results.replaceChildren();
      submit.disabled = false;
    };
    const updateProvinces = () => {
      let provinces = [];
      try { provinces = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch { provinces = []; }
      province.innerHTML = provinces.map(([value, label]) => `<option value="${escapeHtml(value)}">${escapeHtml(label)}</option>`).join('');
      provinceWrap.hidden = provinces.length === 0;
    };
    country.addEventListener('change', updateProvinces);
    form.addEventListener('input', invalidateRates);
    form.addEventListener('change', invalidateRates);
    updateProvinces();
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      shippingController?.abort();
      shippingController = new AbortController();
      const version = ++requestVersion;
      const address = addressKey();
      submit.disabled = true;
      results.hidden = false;
      results.textContent = 'Calculating shipping rates...';
      try {
        const root = String(config.root || '/').replace(/\/?$/, '/');
        const response = await fetch(`${root}cart/shipping_rates.json?${address}`, { headers: { Accept: 'application/json' }, signal: shippingController.signal });
        const payload = await response.json();
        if (version !== requestVersion || address !== addressKey()) return;
        if (!response.ok) throw new Error(Object.values(payload || {}).flat().join(' ') || 'Unable to retrieve shipping rates.');
        const rates = payload.shipping_rates || [];
        results.innerHTML = rates.length
          ? `<p>${rates.length === 1 ? 'There is one shipping rate for your address:' : 'There are several shipping rates for your address:'}</p><ul>${rates.map((rate) => `<li><span>${escapeHtml(rate.name)}</span><strong>${money(Math.round(Number(rate.price) * 100))}</strong></li>`).join('')}</ul>`
          : '<p>Sorry, we do not ship to your address.</p>';
      } catch (error) {
        if (version === requestVersion && address === addressKey() && error.name !== 'AbortError') results.textContent = error.message || 'Unable to retrieve shipping rates.';
      } finally {
        if (version === requestVersion) submit.disabled = false;
      }
    });
  });
  document.querySelector('[data-recover-toggle]')?.addEventListener('click', () => {
    const form = document.querySelector('[data-recover-form]');
    if (form) form.hidden = !form.hidden;
  });
  document.querySelector('[data-new-address-toggle]')?.addEventListener('click', () => {
    const form = document.querySelector('[data-new-address]');
    if (form) form.hidden = !form.hidden;
  });

  document.querySelectorAll('[data-before-after]').forEach((root) => {
    const range = root.querySelector('input[type="range"]');
    const after = root.querySelector('[data-after-image]');
    const update = () => { after.style.clipPath = `inset(0 ${100 - Number(range.value)}% 0 0)`; };
    range.addEventListener('input', update);
    update();
  });

  document.querySelectorAll('.muse-media-grid__video video').forEach((video) => {
    let visible = false;
    let loading = false;
    let starting = false;
    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.preload = 'none';
    video.pause();
    const updatePlayback = () => {
      if (!visible || document.hidden) { video.pause(); return; }
      if (!loading) {
        let promoted = false;
        [video, ...video.querySelectorAll('source')].forEach(source => {
          if (source.dataset.src) { source.src = source.dataset.src; delete source.dataset.src; promoted = true; }
        });
        loading = true;
        video.preload = 'metadata';
        if (promoted || video.readyState === 0) video.load();
      }
      if (video.readyState < 2 || starting || !video.paused || video.error) return;
      starting = true;
      Promise.resolve(video.play()).catch(() => {}).finally(() => {
        starting = false;
        if (!visible || document.hidden) video.pause();
      });
    };
    video.addEventListener('loadeddata', updatePlayback);
    video.addEventListener('canplay', updatePlayback);
    document.addEventListener('visibilitychange', updatePlayback);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.1;
        updatePlayback();
      }, { threshold: [0, 0.1] }).observe(video);
    } else {
      const checkVisible = () => {
        const rect = video.getBoundingClientRect();
        visible = rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
        updatePlayback();
      };
      window.addEventListener('scroll', checkVisible, { passive: true });
      window.addEventListener('resize', checkVisible, { passive: true });
      checkVisible();
    }
  });

  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    carousel.addEventListener('click', (event) => {
      const direction = Number(event.target.closest('[data-carousel-move]')?.dataset.carouselMove || 0);
      if (direction) track.scrollBy({ left: direction * Math.max(260, track.clientWidth * 0.8), behavior: 'smooth' });
    });
  });

  document.querySelectorAll('[data-timeline]').forEach((timeline) => {
    const slides = Array.from(timeline.querySelectorAll('[data-timeline-slide]'));
    const navItems = Array.from(timeline.querySelectorAll('[data-timeline-index]'));
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-selected')));

    const select = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const selected = index === activeIndex;
        slide.classList.toggle('is-selected', selected);
        slide.setAttribute('aria-hidden', String(!selected));
      });
      navItems.forEach((item, index) => item.setAttribute('aria-current', String(index === activeIndex)));
      if (window.innerWidth < 700) navItems[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    timeline.addEventListener('click', (event) => {
      const nav = event.target.closest('[data-timeline-index]');
      if (nav) select(Number(nav.dataset.timelineIndex));
      const direction = Number(event.target.closest('[data-timeline-move]')?.dataset.timelineMove || 0);
      if (direction) select(activeIndex + direction);
    });
  });
})();
